import React from "react";

import {
  LightMode,
  DarkMode,
  SettingsBrightness,
} from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";

import { useThemeMode, ThemePreference } from "../hooks/themeMode";

const label: Record<ThemePreference, string> = {
  system: "Theme: system",
  light: "Theme: light",
  dark: "Theme: dark",
};

const nextTooltip: Record<ThemePreference, string> = {
  system: "Switch to light",
  light: "Switch to dark",
  dark: "Switch to system",
};

const icon = (pref: ThemePreference) => {
  if (pref === "light") return <LightMode fontSize="small" />;
  if (pref === "dark") return <DarkMode fontSize="small" />;
  return <SettingsBrightness fontSize="small" />;
};

const ThemeToggle: React.FC = () => {
  const { preference, cycle } = useThemeMode();
  return (
    <Tooltip title={`${label[preference]} · ${nextTooltip[preference]}`}>
      <IconButton
        onClick={cycle}
        size="small"
        aria-label={label[preference]}
        sx={{
          color: "text.secondary",
          borderRadius: 0.5,
          "&:hover": {
            color: "text.primary",
            backgroundColor: "rgba(127, 127, 127, 0.08)",
          },
        }}
      >
        {icon(preference)}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;
